import { WarningAmberRounded } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

type ModalType = 'SAVE' | 'GENERATE' | null;

export const UnsavedChangesModal = ({
  modalOpen,
  setModalOpen,
  currentCustomer,
  handleDiscardAndSwitch,
}: {
  modalOpen: {
    type: ModalType;
  };
  setModalOpen: Dispatch<
    SetStateAction<{
      type: ModalType;
    }>
  >;
  currentCustomer: string;
  handleDiscardAndSwitch: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={modalOpen.type === 'SAVE'}
      onClose={() => {
        setModalOpen({ type: null });
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberRounded color="warning" /> {t('unsaved_changes')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('you_have_unsaved_changes_for')} <strong>{currentCustomer}</strong>
          {t('if_you_switch_customers_now_these_changes_will_be_discarded')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={() => {
            setModalOpen({ type: null });
          }}
          color="inherit"
        >
          {t('cancel')}
        </Button>
        <Button
          onClick={handleDiscardAndSwitch}
          color="error"
          variant="contained"
        >
          {t('discard_switch')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
